import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { message } from "antd";
import { GetDashboardServiceCategoriesChartData } from "../../../utils/api";
import Loader from "../../shared/Loader";

const options = {
  responsive: true,
  cutout: "65%",
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: (tooltipItem) => `${tooltipItem?.formattedValue}%`,
      },
    },
  },
  layout: {
    padding: 20,
  },
  annotation: {
    annotations: [
      {
        drawTime: "afterDatasetsDraw",
        type: "text",
        id: "text-center",
        x: "50%",
        y: "50%",
        fontColor: "#000",
        text: "Center Text",
        fontSize: 12,
      },
    ],
  },
};

const ServiceProviderCategoriesChart = () => {
  const [serviceProviderCategories, setServiceProviderCategories] = useState(
    {}
  );
  const [loading, setLoading] = useState(true);

  const fetch = async () => {
    try {
      setLoading(true);
      const response = await GetDashboardServiceCategoriesChartData();
      setServiceProviderCategories(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(error || "Unknown error occured. Please try again later.");
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const serviceProviderCategoriesData = {
    labels: [
      "Hair",
      "Nails",
      "Make Up",
      "Skin Care",
      "Hair Removal",
      "Brows & Lashes",
    ],
    datasets: [
      {
        data: [
          serviceProviderCategories?.categoryData?.Hair?.percentage,
          serviceProviderCategories?.categoryData?.Nails?.percentage,
          serviceProviderCategories?.categoryData?.["Make Up"]?.percentage,
          serviceProviderCategories?.categoryData?.Skincare?.percentage,
          serviceProviderCategories?.categoryData?.["Hair Removal"]?.percentage,
          serviceProviderCategories?.categoryData?.["Brows & Lashes"]
            ?.percentage,
        ],
        backgroundColor: [
          "#F1B065",
          "#9A7AC2",
          "#A2F086",
          "#F28581",
          "#F2E56F",
          "#2091FF",
        ],
      },
    ],
  };
  return (
    <div className="sm:w-5/12 w-full flex-1 p-4 pr-0 box-shadow rounded-xl">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-semibold">Service Provider Categories</h2>
      </div>
      <div className="w-full flex flex-row-reverse items-start">
        <div className="w-64 h-64 ml-auto total-deleted relative">
          <div
            className={`absolute top-[72px] left-[80px] flex-col items-center text-center ${
              loading ? "hidden" : "flex"
            }`}
          >
            <span className="text-3xl font-bold">
              {/* {serviceProviderCategories?.Hair?.count +
                serviceProviderCategories?.Nails?.count +
                serviceProviderCategories?.["Make Up"]?.count +
                serviceProviderCategories?.Skincare?.count +
                serviceProviderCategories?.["Hair Removal"]?.count +
                serviceProviderCategories?.["Brows & Lashes"]?.count} */}
              {serviceProviderCategories?.totalSp || 0}
            </span>
            <span className="text-xl font-semibold">
              Service <br /> Providers
            </span>
          </div>
          {loading ? (
            <Loader height="h-[40vh]" />
          ) : (
            <Doughnut data={serviceProviderCategoriesData} options={options} />
          )}
        </div>
        <div className="mt-6 flex flex-col gap-y-3">
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full flex-shrink-0 bg-[#F1B065]" />
            <span className="2xl:text-sm text-[10px] font-bold mr-1">
              {serviceProviderCategories?.categoryData?.Hair?.count}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">Hair</p>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full flex-shrink-0 bg-[#9A7AC2]" />
            <span className="2xl:text-sm text-[10px] font-bold mr-1">
              {serviceProviderCategories?.categoryData?.Nails?.count}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">Nail</p>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full flex-shrink-0 bg-[#A2F086]" />
            <span className="2xl:text-sm text-[10px] font-bold mr-1">
              {serviceProviderCategories?.categoryData?.["Make Up"]?.count}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">Makeup</p>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full flex-shrink-0 bg-[#F28581]" />
            <span className="2xl:text-sm text-[10px] font-bold mr-1">
              {serviceProviderCategories?.categoryData?.Skincare?.count}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">Skin Care</p>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full flex-shrink-0 bg-[#F2E56F]" />
            <span className="2xl:text-sm text-[10px] font-bold mr-1">
              {serviceProviderCategories?.categoryData?.["Hair Removal"]?.count}
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">
              Hair Removal
            </p>
          </div>
          <div className="flex gap-x-1 items-center">
            <div className="w-2 h-2 rounded-full flex-shrink-0 bg-[#2091FF]" />
            <span className="text-[10px] 2xl:text-sm font-bold mr-1">
              {
                serviceProviderCategories?.categoryData?.["Brows & Lashes"]
                  ?.count
              }
            </span>
            <p className="text-[10px] 2xl:text-sm text-black-500">
              Brows & Lashes
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceProviderCategoriesChart;
